import { db, storage } from "./config"
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc, deleteDoc } from "firebase/firestore"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

export const createCart = async (userId, cart) => {
    try {
        // Reference to the "offers" collection
        const cartsRef = collection(db, "carts")

        // Add a new document with a generated ID
        const docRef = await addDoc(cartsRef, {
        sender: userId,
        receiver: cart?.seller_id || cart?.seller || cart?.merchant_id || 'shopify',
        ...cart
    })

        return docRef.id
        // console.log("Document written with ID: ", docRef.id)
    } catch (e) {
        console.error("Error adding document: ", e)
    }
}

export const updateCartQuantity = async (cartId, quantity) => {
    try {
        // Reference to the specific offer document
        const offerRef = doc(db, "carts", cartId)

        // Update the document with new data
        await updateDoc(offerRef, { quantity })
        
        console.log("Document updated with ID: ", updatedData.id)
    } catch (e) {
        console.error("Error updating document: ", e)
    }
}

export const deleteCart = async (cartId) => {
    try {
        // Reference to the specific category document
        const cartsRef = doc(db, "carts", cartId);

        // Delete the document
        await deleteDoc(cartsRef);

        console.log("Document deleted with ID: ", cartId);
    } catch (e) {
        console.error("Error deleting document: ", e);
    }
}

export const listingIsInCart = async (userId, cardId) => {
    try {
        // Reference to the "carts" collection
        const cartsRef = collection(db, "carts");

        // Create a query to check if the card already exists for the user
        const q = query(cartsRef, where("user", "==", userId), where("cardId", "==", cardId));

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Check if the card is already in the cart
        if (querySnapshot.empty) {
            // If not, add a new document with a generated ID
            return false
        } else {
            return true
        }
    } catch (e) {
        console.error("Error adding document: ", e);
    }
};